module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('h1', {
    staticClass: "Hidden-Title"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Title Page")]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/C&D_logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "presents"
  }, [_vm._v("presents")]), _vm._v(" "), _c('p', {
    staticClass: "Iconic-Cars"
  }, [_vm._v("Iconic Cars")]), _vm._v(" "), _c('p', {
    staticClass: "main_title"
  }, [_vm._v("Porsche")]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/RosettaBooks_Logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher_city"
  }, [_vm._v("New York 2015")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dee4dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Porsche__1__TP.vue
// module id = 60
// module chunks = 0